import { render } from "./AmazingdealsCom.vue?vue&type=template&id=0fd7c0f6&scoped=true"
const script = {}

import "./AmazingdealsCom.vue?vue&type=style&index=0&id=0fd7c0f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd7c0f6"]])

export default __exports__